<template>
  <div id="vue-app-container" class="h-full w-full">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: 'VueApp',
  mounted() {
    this.$store.dispatch('tours/initializeFromStorage')
    this.$store.dispatch('visited/initializeFromStorage')
  },
}
</script>